import React from "react";
import NewHeroSection from "../components/NewHeroSection";
import {
  amenitiesIcon1,
  amenitiesImage,
  bigPriceImage,
  bookingBg,
  deluxePriceImage,
  minusIcon,
  missionImage,
  newAboutImage,
  newWelcomeImage,
  onePriceImage,
  playIcon2,
  plusIcon,
  priceImage,
  threePriceImage,
  twoPriceImage,
  valueIcon1,
} from "../assets";
import { useNavigate } from "react-router-dom";
import Amenities from "../components/Amenities";
import Values from "../components/Values";
import Ikeja from "../components/Ikeja";
import Video from "../components/Video";

const NewHomePage = () => {
  const navigate = useNavigate();

  const handleNavigation = (location) => {
    navigate(`/booking?location=${location}`);
  };

  const styles = {
    backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${bookingBg})`,
    // backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.6)), url(${sliderImages[current].imageUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center center",
  };

  return (
    <div>
      <NewHeroSection />
      <div className="flex flex-col-reverse md:flex-row md:px-[100px] px-4 gap-12 items-center mb-8">
        <img src={newAboutImage} alt="" className="md:w-[40%]" />
        <div className="">
          <h2 className="text-[#00A859] font-bold font-trajan md:text-3xl text-2xl mb-2">
          ABOUT <span className="text-transparent stroke-green stroke-2 font-light">US</span>
          </h2>
          <p className="text-[#B2B2B2] mb-6 font-barlow">
          Welcome to The Imperial by WosAm Apartments, where comfort meets elegance. Nestled in serene neighborhoods across Lagos, Ogun, and the Federal Capital Territory, Abuja, our luxury apartments offer a unique blend of modern sophistication and homely warmth. Whether you're here for business, leisure, or a long-term stay, The Imperial provides an unparalleled living experience tailored to meet your every need.
          </p>
          {/* <button
            className="md:py-3 py-2 px-6 text-white bg-[#00A859] font-bold"
            onClick={() => navigate("/booking")}
          >
            BOOK NOW
          </button> */}
        </div>
      </div>
      <div className="flex md:flex-row-reverse flex-col-reverse md:mx-[100px] md:pl-10 md:pr-0 px-4 md:pt-0 pt-10 gap-12 md:justify-between items-center bg-[#FFF5DF]">
        <img src={missionImage} alt="" className="md:w-[40%]" />
        <div className="">
          <h2 className="text-[#FF9900] font-bold font-trajan md:text-3xl text-2xl mb-2">
          <span className="text-transparent stroke-yellow stroke-2 font-light">OUR</span> MISSION
          </h2>
          <p className="text-[#B2B2B2] mb-6 font-barlow">
          At The Imperial by WosAm Apartments, our mission is to redefine urban living by offering world-class hospitality services that exceed our guests' expectations. We are dedicated to creating a comfortable and luxurious environment where every detail is designed with our residents' well-being in mind.
          </p>
          {/* <button
            className="md:py-3 py-2 px-6 text-white bg-[#FF9900] font-bold"
            onClick={() => navigate("/booking")}
          >
            BOOK NOW
          </button> */}
        </div>
      </div>
      <Values />
      {/* <Video videoId="5qa4RI_sxKo" /> */}
      <div className="flex md:flex-row flex-col gap-10 md:px-[100px] px-4 mb-16">
        <div className="flex flex-col md:gap-6">
          <div className="relative text-white">
            <img src={bigPriceImage} alt="" className="" />
            {/* <div className="absolute md:top-6 md:right-6 top-4 right-6">
              <button
                className="md:py-3 py-2 px-6 text-white bg-[#00A859] font-bold"
                onClick={() => navigate("/booking")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <p className="font-light"></p>
              <p className="font-semibold text-lg">Luxury Two Bedroom Apartment with Cinema</p>
            </div> */}
          </div>
          <div className="bg-[#FFF5DF] md:h-[250px] h-[200px] flex flex-col items-center justify-center">
            <p className="text-[#B2B2B2] mb-6 font-barlow text-center w-[70%]">
            At The Imperial by WosAm Apartments, we offer a range of premium amenities designed to make your stay as comfortable and enjoyable as possible.
            </p>
            <button
              className="md:py-3 py-2 px-6 text-white bg-[#FF9900] font-bold"
              onClick={() => navigate("/booking")}
            >
              BOOK NOW
            </button>
          </div>
        </div>
        <div className="">
          <div className="flex items-center justify-center md:h-[275px] h-[100px] bg-[#FFF5DF]">
            <h3 className="text-[#FF9900] font-bold font-trajan text-2xl mb-2 text-center">
            <span className="text-transparent stroke-yellow stroke-2 font-light">OUR</span> <br className="md:block hidden" /> APARTMENTS
            </h3>
          </div>
          <div className="relative text-white">
            <img src={onePriceImage} alt="" className="" />
            {/* <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-3 py-2 px-6 text-white bg-[#00A859] font-bold"
                onClick={() => navigate("/booking")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-8 md:right-8 bottom-4 left-4 font-barlow">
              <p className="font-light"></p>
              <p className="font-semibold text-lg">Executive Three Bedroom Apartment</p>
            </div> */}
          </div>
        </div>
      </div>
      <div className="md:px-[100px] px-4 grid md:grid-cols-3 grid-cols-1 gap-4 mb-16">
        <div className="relative text-white">
          <img src={twoPriceImage} alt="" className="h-[500px]" />
          {/* <img src={twoPriceImage} alt="" className="h-[500px]" /> */}
          <div className="absolute md:top-6 md:right-6 top-4 right-4">
            <button
              className="md:py-3 py-2 px-6 text-white bg-[#00A859] font-bold"
              onClick={() => handleNavigation("lagos")}
            >
              LAGOS
            </button>
          </div>
          <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
            <p className="font-light"></p>
            <p className="font-semibold text-lg">The Imperial, Lagos</p>
          </div>
        </div>
        <div className="relative text-white">
          <img src={threePriceImage} alt="" className="h-[500px]" />
          <div className="absolute md:top-6 md:right-6 top-4 right-4">
            <button
              className="md:py-3 py-2 px-6 text-white bg-[#00A859] font-bold"
              onClick={() => handleNavigation("abuja")}
            >
              ABUJA
            </button>
          </div>
          <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
            <p className="font-light"></p>
            <p className="font-semibold text-lg">The Imperial, Abuja</p>
          </div>
        </div>
        <div className="relative text-white">
          <img src={deluxePriceImage} alt="" className="h-[500px]" />
          <div className="absolute md:top-6 md:right-6 top-4 right-4">
            <button
              className="md:py-3 py-2 px-6 text-white bg-[#00A859] font-bold"
              onClick={() => handleNavigation("ogun")}
            >
              OGUN
            </button>
          </div>
          <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
            <p className="font-light"></p>
            <p className="font-semibold text-lg">The Imperial, Ogun</p>
          </div>
        </div>
      </div>
      
      {/* <div className="">
        <div className="flex justify-between items-center">

        </div>
      </div> */}
      <Amenities />
      {/* <Ikeja /> */}
      {/* <div className="px-[100px] my-16 flex flex-col gap-10">
        <div className="flex justify-between items-center gap-24">
          <div className="">
            <p className="text-[#B2B2B2] font-barlow">
              Welcome to WosAm Luxury Apartments, where comfort meets elegance.
              Nestled in the serene neighborhood of Ikeja GRA in Lagos, our
              luxury apartments offer a unique blend of modern sophistication
              and homely warmth.
            </p>
          </div>
          <img src={newWelcomeImage} alt="" className="w-[48%]" />
        </div>
        <div className="flex flex-row-reverse justify-between items-center gap-24">
          <div className="">
            <p className="text-[#B2B2B2] font-barlow">
              Welcome to WosAm Luxury Apartments, where comfort meets elegance.
              Nestled in the serene neighborhood of Ikeja GRA in Lagos, our
              luxury apartments offer a unique blend of modern sophistication
              and homely warmth.
            </p>
          </div>
          <img src={newWelcomeImage} alt="" className="w-[48%]" />
        </div>
      </div> */}
    </div>
  );
};

export default NewHomePage;
